<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t(serviceFee===0?'common.tip':'common.tipServiceFee')" center width="800px"
    :close-on-click-modal="false" @close="close">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-fs">

          <div class="left df-l-fs">
            <div class="item df-c-fs" v-if="serviceFee">
              <span class="f-xs">{{$t('common.serviceFee')}}：</span>
              <span class="f-xxxl _redcolor">{{serviceFee|toprice(2)}}</span>
            </div>
            <div class="item df-c-fs">
              <span class="f-xs">{{$t('common.tip')}}：</span>
              <InputCustom
                :inputable="true"
                inputWidth="240"
                :inputPlaceholder="$t('calc.inputCustomPrice_cashdialog')"
                :inputValue="moneyNumber" />
            </div>
            <div class="item df-c-fs" v-if="serviceFee">
              <span class="f-xs">{{$t('common.total')}}：</span>
              <span class="f-xxxl _redcolor">{{total|toprice(2)}}</span>
            </div>
          </div>

          <div class="right f1 df-c-ct">
            <Keyboard :inputValue.sync="moneyNumber"  :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel showDoubleZero />
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogTip',
  props: {
    scan_canLeave_open: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      isShowDialog: false,
      oid: '',
      moneyNumber: '',
      serviceFee: 0,
      total: 0,
    }
  },
  watch: {
    moneyNumber(n, o) {
      this.total = Number(n) + this.serviceFee
    }
  },
  methods: {
    open(val0, val1, val2) {
      this.oid = val0
      this.serviceFee = val1
      this.moneyNumber = String(val2)
      if (this.scan_canLeave_open) {
        this.scan_canLeave_x_save(false)
      }
      this.isShowDialog = true
    },
    close() {
      this.$emit('close')
      if (this.scan_canLeave_open) {
        this.scan_canLeave_x_save(true)
      }
      this.isShowDialog = false
      this.oid = ''
      this.moneyNumber = ''
      this.serviceFee = 0
      this.total = 0
    },
    // 支付对话框 提交支付方式
    async submitDialog() {
      if (this.moneyNumber === '' && this.serviceFee !== 0) {
      } else {
        this.moneyNumber === '' && (this.moneyNumber = 0)
        
        // this.$emit('submitDialog', {
        //   id: this.oid,
        //   serviceFee: this.serviceFee,
        //   tipsFee: Number(this.moneyNumber),
        // })

        const rD = {
          id: this.oid,
          shopId: this.currentShopId,
          serviceFee: this.serviceFee,
          tipsFee: Number(this.moneyNumber),
        }
        const _R = await this.setData('order', rD)
        if (_R) {
          this.$emit('submitDialog', _R)
          this.close()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 40px 0;
  .left{
    .item{padding: 10px 0;}
  }
}
</style>